var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagementFee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 13H3.0625C2.81641 13 2.625 13.2188 2.625 13.4375V14.3125C2.625 14.5586 2.81641 14.75 3.0625 14.75H14.4375C14.6562 14.75 14.875 14.5586 14.875 14.3125V13.4375C14.875 13.2188 14.6562 13 14.4375 13ZM16.1875 4.25C15.4492 4.25 14.875 4.85156 14.875 5.5625C14.875 5.78125 14.9023 5.94531 14.9844 6.10938L13.0156 7.3125C12.5781 7.55859 12.0312 7.42188 11.7852 6.98438L9.57031 3.07422C9.87109 2.85547 10.0625 2.47266 10.0625 2.0625C10.0625 1.35156 9.46094 0.75 8.75 0.75C8.01172 0.75 7.4375 1.35156 7.4375 2.0625C7.4375 2.47266 7.62891 2.85547 7.90234 3.07422L5.6875 6.98438C5.44141 7.42188 4.89453 7.55859 4.48438 7.3125L2.48828 6.10938C2.57031 5.94531 2.625 5.78125 2.625 5.5625C2.625 4.85156 2.02344 4.25 1.3125 4.25C0.574219 4.25 0 4.85156 0 5.5625C0 6.30078 0.574219 6.875 1.3125 6.875C1.36719 6.875 1.44922 6.875 1.50391 6.875L3.5 12.125H14L15.9688 6.875C16.0234 6.875 16.1055 6.875 16.1875 6.875C16.8984 6.875 17.5 6.30078 17.5 5.5625C17.5 4.85156 16.8984 4.25 16.1875 4.25Z",
    fill: "#0C0B0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementFee);
export default __webpack_public_path__ + "static/media/management-fee.6377c654371fdef1c699402117f59646.svg";
export { ForwardRef as ReactComponent };